module.exports = __webpack_public_path__ + "static/img/pics1.40ded94e.png";